var _rect, _rect2, _path, _path2, _rect3, _path3, _path4, _circle, _circle2, _circle3, _circle4, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#fffbeb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 65,
    width: 45,
    height: 28,
    rx: 4,
    fill: "white",
    stroke: "#d97706",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 93 L112 175 C110 188 120 198 135 198 L170 198 C185 198 195 188 193 175 L175 93Z",
    fill: "white",
    stroke: "#d97706",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117 160 L188 160 L193 175 C195 188 185 198 170 198 L135 198 C120 198 110 188 112 175Z",
    fill: "#fef3c7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 75,
    width: 45,
    height: 28,
    rx: 4,
    fill: "white",
    stroke: "#0d9488",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235 103 L220 172 C218 185 228 195 243 195 L270 195 C285 195 295 185 293 172 L278 103Z",
    fill: "white",
    stroke: "#0d9488",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225 158 L288 158 L293 172 C295 185 285 195 270 195 L243 195 C228 195 218 185 220 172Z",
    fill: "#ccfbf1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 178,
    r: 4,
    fill: "#fbbf24",
    opacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 186,
    r: 3,
    fill: "#fbbf24",
    opacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 175,
    r: 4,
    fill: "#14b8a6",
    opacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 183,
    r: 3,
    fill: "#14b8a6",
    opacity: 0.3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 250,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#92400e"
  }, "Laboratuvar")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabTest);
export default __webpack_public_path__ + "static/media/lab-test.e7cb281e6e664821be6788e8a4ad1458.svg";
export { ForwardRef as ReactComponent };